import { h, Fragment } from "preact";
import { useState } from "preact/hooks";
import SwatchProductActions from "../swatch-product-actions";
import { CSSTransition } from "react-transition-group";
import SwatchToast from "../swatch-toast";

export default function SwatchProduct({
  product,
  cartItems,
  limitEach,
  swatchType,
}) {
  const [error, setError] = useState(null);
  const [toast, setToast] = useState(null);
  const item = cartItems.find(
    (cartItem) => parseInt(cartItem.variant_id) === product.variant_id,
  );

  const onError = () => {
    setError(window.localeStrings.product.add_to_cart_error);
    setTimeout(() => {
      setError(null);
    }, 3000);
  };

  const onAfterAdd = () => {
    setToast(window.localeStrings.swatch_modal.added_to_cart);
  };

  const onAfterRemove = () => {
    setToast(window.localeStrings.swatch_modal.removed_from_cart);
  };

  return (
    <div className="pdp-swatch-modal__product">
      {product.image ? (
        <img
          className="pdp-swatch-modal__product-image"
          src={product.image}
          alt=""
        />
      ) : (
        <div className="pdp-swatch-modal__product-image pdp-swatch-modal__product-image--blank"></div>
      )}
      <SwatchToast message={toast} setMessage={setToast} />
      <a href={product.url} className="pdp-swatch-modal__product-title">
        {product.title}
      </a>
      <SwatchProductActions
        variantId={product.variant_id}
        productGid={product.product_gid}
        item={item}
        limitEach={limitEach}
        onError={onError}
        onAfterAdd={onAfterAdd}
        onAfterRemove={onAfterRemove}
        classPrefix="pdp-swatch-modal"
        removeButtonClasses="button button--grey button--full"
        addButtonClasses="button button--black-outline button--full"
        addToCartText={window.localeStrings.swatch_modal.add_to_cart}
        removeFromCartText={window.localeStrings.swatch_modal.remove_from_cart}
        swatchType={swatchType}
      />
      {product.price > 0 && (
        <price-snippet
          className="pdp-swatch-modal__product-price"
          DYNAMIC
          PRICE={product.price / 100}
          CURRENCY={window.Shopify.currency.active}
        ></price-snippet>
      )}
      {error && (
        <div
          className="pdp-swatch-modal__error"
          dangerouslySetInnerHTML={{
            __html: error,
          }}
        ></div>
      )}
    </div>
  );
}
